import React, { FC, ReactNode, useEffect } from 'react';
import { IonItem, IonIcon, IonLabel } from '@ionic/react';
import { chevronDownOutline, chevronForwardOutline } from 'ionicons/icons';
import { AppPage } from '../../../hooks/useRoutes';

export const MenuAccordion: FC<{
  page: AppPage;
  isLast: boolean;
  className?: string;
  children: ReactNode;
  level: number;
  shouldResetMenu: boolean;
  expanded?: boolean;
}> = ({ page, className, children, shouldResetMenu, level, expanded }) => {
  const [isOpen, setIsOpen] = React.useState(true);

  useEffect(() => {
    if (shouldResetMenu) {
      setIsOpen(false);
    } else if (expanded && page.url.includes('factory-gpt')) {
      setIsOpen(true);
    }
  }, [shouldResetMenu, expanded]);

  return (
    <>
      <IonItem
        className={`menu-link-group accordion-level-${level} typography 
          ${level === 0 ? 'menu-margin' : ''}`}
        button
        onClick={() => setIsOpen(!isOpen)}
        style={{ color: 'white' }}
        mode="md"
      >
        {page.customIcon || <IonIcon slot="start" ios={page.iosIcon} md={page.mdIcon} />}

        <IonLabel color="light" className="menu-link-group">
          {page.title}
        </IonLabel>
        <IonIcon slot="end" icon={isOpen ? chevronDownOutline : chevronForwardOutline} />
      </IonItem>
      {isOpen && children}
    </>
  );
};
